import useResizeObserver from '@react-hook/resize-observer';
import { useMotionValueEvent } from 'framer-motion';
import { debounce, isEqual } from 'lodash-es';
import { useState } from 'react';
import { defaultZoomControllerButtonAvailability as defaultButtonAvailability, defaultZoomControllerButtonAvailability } from '../types/button-availability';
import { getElementMaximumScrollPosition } from '../utils/get-element-maximum-scroll-position';
export function useButtonAvailability(handler) {
    const [state, setState] = useState(defaultButtonAvailability);
    // Gets the new state based on the current scale and scroll position.
    const getNewState = () => {
        const container = handler.viewportRef.current;
        if (!container) {
            return defaultZoomControllerButtonAvailability;
        }
        const scale = handler.scale.get();
        const minScale = handler.minScale.get();
        const maxScale = handler.maxScale.get();
        const scrollPosition = handler.scrollPosition.get();
        const maxScrollPosition = getElementMaximumScrollPosition(container);
        return {
            zoomIn: scale < maxScale,
            zoomOut: scale > minScale,
            resetZoom: scale > minScale,
            panUp: maxScrollPosition.y > 0 && scrollPosition.y > 0,
            panDown: maxScrollPosition.y > 0 && Math.abs(maxScrollPosition.y - scrollPosition.y) > 1,
            panLeft: maxScrollPosition.x > 0 && scrollPosition.x > 0,
            panRight: maxScrollPosition.x > 0 && Math.abs(maxScrollPosition.x - scrollPosition.x) > 1
        };
    };
    const updateState = debounce(() => {
        const newState = getNewState();
        // Only update the state if it has changed to avoid unnecessary re-renders.
        if (!isEqual(state, newState)) {
            setState(newState);
        }
    }, 10);
    // Update the state when the scale or scroll position change.
    useMotionValueEvent(handler.scale, 'change', updateState);
    useMotionValueEvent(handler.scrollPosition, 'change', updateState);
    // Update the state when the viewport is resized.
    useResizeObserver(handler.viewportRef, updateState);
    return state;
}
//# sourceMappingURL=use-button-availability.js.map